/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * App the receiving side will open a session for. The caller must pass that app’s access gate — the gate is enforced here, so a client-side app list is only ever a UX hint.
 */
export type LoginApp = (typeof LoginApp)[keyof typeof LoginApp];

export const LoginApp = {
  client: "client",
  manager: "manager",
  dashboard: "dashboard",
} as const;
